import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, lifecycle } from 'recompose'
import withMixpanel, { SCREEN_VIEW_SETTINGS_ORGANISATION } from 'utils/mixpanel'

import * as toastModule from 'modules/toast'
import * as organisationModule from 'modules/organisation'

export default compose(
  withMixpanel,
  connect(
    (state) => {
      return {
        organisation: idx(state, _ => _.organisation.selected),
        hasError: idx(state, _ => _.progress.updateOrganisation.hasError) || false,
        errorMessage: idx(state, _ => _.progress.updateOrganisation.error.message) || null,
      }
    },
    (dispatch) => {
      const actions = {
        ...organisationModule,
        ...toastModule,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  // Handlers
  withHandlers({
    showUpdateSuccessToast: ({ actions }) => (organisationName) => {
      actions.showToast(toastModule.SUCCESS_TOAST, `'${organisationName}' has been successfully updated`)
    },
  }),
  withHandlers({
    onFormSubmit: ({ actions, showUpdateSuccessToast }) => (organisation, organisationFields) => {
      actions.updateOrganisation(organisation, organisationFields, () => {
        // disable image upload for now. Bugs here anway.
        /*
        const imageDeleted = organisationFields.image === null
        const imageUpdated = organisationFields.image && organisationFields.image.src

        if (imageUpdated) {
          actions.updateOrganisationImage(organisation, organisationFields.image, () => showUpdateSuccessToast(organisationFields.name))
        } else if (imageDeleted) {
          actions.deleteOrganisationImage(organisation, () => showUpdateSuccessToast(organisationFields.name))
        } else {
          showUpdateSuccessToast(organisationFields.name)
        }
        */
        showUpdateSuccessToast(organisationFields.name)
      })
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.track(SCREEN_VIEW_SETTINGS_ORGANISATION)
    }
  })
)



// WEBPACK FOOTER //
// ./src/containers/organisation/OrganisationOverview/OrganisationOverview.enhancer.js